<div class="layout-container">
  <!-- Sidebar -->

  <app-sidebar></app-sidebar>
  <!-- Main Content -->
  <div class="flex flex-1 min-w-0 flex-col">
    <app-demo-cta />
    <div class="main-content">
      <router-outlet />
    </div>
  </div>

  <!-- Mobile Toolbar -->
  <app-mobile-toolbar></app-mobile-toolbar>
</div>

<!-- Modales globales pour Discovery Flow -->
<app-onboarding-popup></app-onboarding-popup>
<app-contact-sales-modal></app-contact-sales-modal>
<app-update-notes-modal></app-update-notes-modal>
